<template>
  <div>
    <div class="superuser-gift-card-search__top">
      <validation-observer
        ref="superuserGiftCard"
        tag="form"
        class="superuser-gift-card-search__form"
        @submit.prevent
        @keyup.enter="searchGiftCard()">
        <validation-provider v-slot="{errors}" slim>
          <oie-base-input
            id="query"
            v-model="query"
            :label-text="t('superuserGiftcardSearchLabel')"
            :placeholder="t('superuserGiftcardSearchPlaceholder')"
            :error-messages="errors"
            class="superuser-gift-card-search__input"></oie-base-input>
        </validation-provider>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/giftcard/search' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          :text="t('superuserGiftcardSearchButton')"
          @click="searchGiftCard()"></oie-base-button>
      </validation-observer>

      <div>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/giftcard/sendToErp' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          :text="t('superuserGiftcardExportErpButton')"
          @click="exportGiftCards()"></oie-base-button>
      </div>
    </div>

    <div class="superuser-search-result">
      <div v-if="mq('medium')" class="superuser-search-result__head">
        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnId') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnCode') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnOrderNumber') }})
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnOriginalValue') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnRemainingAmount') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnCurrency') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnPurchaseDate') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnLastUsedDate') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnValidUntil') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          {{ t('superuserGiftcardColumnStatus') }}
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          &nbsp;
        </div>
      </div>

      <template v-if="giftCardRows === null">
        <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
          {{ t('superuserGiftcardSearchInstruction') }}
        </div>
      </template>

      <template v-else-if="giftCardRows && giftCardRows.length === 0">
        <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
          {{ t('superuserSearchNoHits') }}
        </div>
      </template>

      <div
        v-for="(row, i) in giftCardRows"
        v-else
        :key="row.id"
        v-element-loader="{ endpoint: 'superuser/synccustomer/' + row.id }"
        :class="row.removed ? 'superuser-gift-card-search-result__body-row superuser-gift-card-search-result__body-row_removed' : 'superuser-gift-card-search-result__body-row'">
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnId') }}
          </div>
          {{ row.id }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnCode') }}
          </div>
          {{ row.code }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnOrderNumber') }}
          </div>
          {{ row.orderNumber }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnOriginalValue') }}
          </div>
          {{ row.amount }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnRemainingAmount') }}
          </div>
          {{ row.balance }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnCurrency') }}
          </div>
          {{ row.currency }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnPurchaseDate') }}
          </div>
          {{ row.createDate }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnLastUsedDate') }}
          </div>
          {{ row.lastUsed }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnValidUntil') }}
          </div>
          {{ row.validUntil }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserGiftcardColumnStatus') }}
          </div>
          {{ row.status }}
        </div>
        <div v-if="!row.removed" class="superuser-gift-card-search-result__cell superuser-gift-card-search-result__cell--actions">
          <oie-base-button
            css-classes="superuser-search-results__action button--gray"
            :text="t('superuserGiftcardButtonEdit')"
            @click="openGiftCardDetailsView(row, i)"></oie-base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    query: null,
    giftCardRows: null
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    async searchGiftCard() {
      const isValid = await this.$refs.superuserGiftCard.validate()

      if (!isValid) {
        return
      }

      httpService.post('superuser/giftcard/search', { query: this.query, customerNumber: this.customerNumber })
        .then(({ data }) => {
          this.giftCardRows = data
        })
    },
    openGiftCardDetailsView(giftcard, index) {
      this.publish('superuser-edit-gift-card', { giftcard, index })
    },
    async exportGiftCards() {
      httpService.post('superuser/giftcard/sendToErp').then((response) => {
      })
    }
  } }
</script>

<style lang="scss">
.superuser-gift-card-search-result__body-row {
  display: flex;
  flex-wrap: wrap;
}

.superuser-gift-card-search-result__cell {
  flex: 1;
  padding: 6px; /* Adjust as needed */
  box-sizing: border-box;
  overflow: hidden; /* Prevent overflowing content */
}

.superuser-gift-card-search-result__cell-title {
  font-weight: bold;
  flex: 1;
  padding: 8px; /* Adjust as needed */
  box-sizing: border-box;
  overflow: hidden; /* Prevent overflowing content */
}

.superuser-gift-card-search-result__cell--actions {
  flex: 1;
}

.superuser-gift-card-search__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-gift-card-search__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 40rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-gift-card-search__input,
.superuser-gift-card-search__input-wide {
  min-width: 10rem;
  max-width: 20rem;
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}
</style>
